import { FC } from "react";
import SkeletonBox from "./SkeletonBox";

const SkeletonPageTitle: FC = () => (
  <SkeletonBox h={38} w="100%" maxWidth="300px" mb={6} />
);

export default SkeletonPageTitle;
